<template>
  <div>
    <!-- Mission Price, Note -->
    <div class="mb-3">
      <div class="d-block" v-if="showLabel">
        <v-row>
          <v-col class="pb-0">
            <heading-title
              :title="$t('mission.mission_title_for_section')"
            ></heading-title>
          </v-col>
          <v-spacer></v-spacer>
          <!-- <v-col cols="12" sm="1" class="pb-0">
                <heading-title
                    :title="$t('mission.mission_title_for_section')"
                ></heading-title>
            </v-col> -->
        </v-row>
      </div>
      <div class="d-block mt-n5">
        <v-row>
          <v-col cols="12" sm="3">
            <!-- Mission Search Component -->
            <v-autocomplete
              :disabled="selectedBill ? true : false"
              :autocomplete="autocompleteValueLocal"
              v-model="selectedMission"
              class="mr-2 mt-5 pt-1 to-upper"
              :items="missions"
              :search-input.sync="search_mission"
              item-text="identifier"
              item-value="id"
              :loading="isLoadingSearchRegMissions"
              :label="$t('mission.search_mission')"
              :placeholder="$t('mission.start_typing')"
              return-object
              :clearable="selectedMission ? true : false"
              clear-icon="mdi-close"
              v-on:keydown="handleInput($event, 'alphanumeric', 20)"
              v-on:keydown.enter.prevent=""
              :background-color="
                setMissionRowColorClass(selectedMission?.status_id, true)
              "
              ref="missionDropdown"
              @click:clear="
                resetData();
                search_mission = null;
              "
              :readonly="
                selectedMission !== null && selectedMission !== undefined
              "
              :hide-no-data="true"
              dense
              :style="{
                maxWidth: '350px',
                minWidth: '350px',
                fontSize: '16px',
              }"
              :hide-details="true"
            >
              <template slot="item" slot-scope="{ item }">
                <div
                  :class="setMissionRowColorClass(item, true)"
                  class="pl-2"
                  style="width: 100%"
                >
                  <v-list-item-content @click="selectedMission = item">
                    <span v-if="item.mission_type" class="mission_type">
                      {{ $t("mission.types." + item.mission_type.key) }}
                    </span>
                    <br />
                    <span>
                      <strong>{{ item.identifier }}</strong>
                    </span>
                    <br />
                    <span class="client_name" v-if="item.client">
                      {{ item.client.name }}
                      {{ item.client.first_name ? item.client.first_name : "" }}
                    </span>
                  </v-list-item-content>
                </div>
              </template>
              <template #prepend-inner> </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-select
              :autocomplete="autocompleteValueLocal"
              v-model="mission_type"
              :items="missionTypes"
              item-value="id"
              class="to-upper"
              item-text="text"
              :label="$t('mission.what_to_do')"
              :outlined="is_boxes"
              :dense="is_boxes"
              @change="emitValues()"
              :hide-details="true"
            ></v-select>
          </v-col>
          <v-col v-if="selectedMission">
            <v-select
              v-if="selectedMission"
              disabled
              :autocomplete="autocompleteValueLocal"
              v-model="status_id"
              :items="missionStatuses"
              item-text="text"
              class="to-upper"
              item-value="id"
              return-object
              :label="$t('mission.status')"
              :background-color="setMissionRowColorClass(status_id, true)"
              :hide-details="true"
            >
              <!-- Item slot for dropdown options -->
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item
                  v-bind="attrs"
                  v-on="on"
                  :class="setMissionRowColorClass(item, true)"
                  class="pa-0 ma-0 pl-2"
                  style="color: black !important; width: 100%"
                >
                  <v-list-item-content>
                    {{ item.text }}
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col>
            <v-text-field
              class="to-upper"
              v-model="reference"
              :label="$t('mission.reference')"
              :required="true"
              :hide-details="true"
              @change="emitValues()"
            ></v-text-field>
          </v-col>
          <v-col>
            <custom-money-input
              @change="emitValues()"
              :autocomplete="autocompleteValueLocal"
              class="pr-0 to-upper right-aligned-input shrink"
              hide-details="auto"
              outlined
              dense
              tabindex="3"
              :label="$t('mission.price')"
              v-model="price"
              v-bind:properties="{
                prefix: currencySymbol,
                readonly: false,
                disabled: false,
                outlined: false,
                placeholder: getDecimalNumber() == 2 ? '0.00' : '0.000',
                dense: false,
                hideDetails: 'true',
              }"
              v-bind:options="{
                locale: userLanguageId,
                length: 12,
                precision: getDecimalNumber(),
                empty: getDecimalNumber() == 2 ? 0.0 : 0.0,
              }"
            />
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- Mission Location-->
    <div>
      <v-row>
        <v-col class="pl-0 pt-0">
          <AddressInput
            ref="shipping_address"
            v-model="source_location"
            :defaultAddressType="'main_address'"
            :label="$t('mission.source_location')"
            class="mt-n3"
          />
        </v-col>
        <v-col class="pl-0 pt-0">
          <AddressInput
            ref="shipping_address"
            v-model="destination_location"
            :defaultAddressType="'main_address'"
            :label="$t('mission.destination_location')"
            class="mt-n3"
          />
        </v-col>
      </v-row>
    </div>

    <!-- Mission Contact-->
    <div>
      <v-row class="ml-1">
        <v-row>
          <!-- Contact Name -->
          <v-col cols="12" sm="2">
            <v-text-field
              class="to-upper"
              v-model="contact.name"
              :label="$t('mission.mission_contact_section')"
              :required="true"
              :hide-details="true"
              @input="emitValues()"
            ></v-text-field>
          </v-col>
          <!-- Contact GSM -->
          <v-col cols="12" sm="2">
            <vue-tel-input-vuetify
              :preferredCountries="preferredCountry"
              :filterCountries="onlyCountries"
              :disabledFetchingCountry="true"
              validCharactersOnly
              :label="$t('mission.contact_gsm')"
              :inputOptions="{ showDialCode: true, tabindex: 0 }"
              :mode="'international'"
              v-model="contact.gsm"
            ></vue-tel-input-vuetify>
          </v-col>
          <!-- Contact Phone -->
          <!-- <v-col>
            <v-text-field
              class="to-upper"
              v-model="contact.phone"
              :label="$t('mission.contact_phone')"
              :required="true"
              :hide-details="true"
              @input="emitValues()"
            ></v-text-field>
          </v-col> -->

          <!-- Vehicle -->
          <v-col cols="12" sm="8" class="mt-2">
            <create-edit-vehicle
              ref="vehicleComp"
              :comp_vehicle_type.sync="vehicle.vehicle_type_id"
              :comp_registration_no.sync="vehicle.registration_number"
              :comp_brand.sync="vehicle.brand"
              :comp_model.sync="vehicle.model"
              :comp_km.sync="vehicle.km"
              :comp_vin.sync="vehicle.vin"
              :comp_color.sync="vehicle.color"
              :comp_is_leasing.sync="vehicle.is_leasing"
              :show_creditor_input="false"
              :show_driver_input="false"
              :left_padding="false"
              :show_color="true"
              :showVehicleLabel="false"
              :showKm="false"
              :showVin="false"
              :showEditVehicleButton="false"
              :registrationNumberLabel="$t('mission.mission_vehicle_section')"
            />
          </v-col>
        </v-row>
      </v-row>
    </div>

    <!-- Towing Partner -->
    <div class="mt-3">
      <!-- <div class="d-block">
        <v-row>
          <v-col cols="12" sm="2" class="mb-0 pb-0">
            <heading-title
              :title="$t('mission.towing_partner')"
            ></heading-title>
          </v-col>
          <v-spacer></v-spacer>
          
        </v-row>
      </div> -->
      <div class="d-block mt-n6">
        <v-row>
          <!-- Towing Company -->
          <v-col class="pt-0">
            <v-autocomplete
              :autocomplete="autocompleteValueLocal"
              ref="towingPartnerName"
              v-model="towing_partner"
              :label="$t('mission.towing_partner')"
              :items="towingPartners"
              item-value="id"
              item-text="name"
              required
              class="to-upper clickable_label"
              v-on:keydown="handleInput($event, 'everything', 50)"
              :search-input.sync="searchTowingPartner"
              no-filter
              v-on:keydown.enter.prevent=""
              return-object
              single-line
              hide-no-data
              clearable
              @click:clear="removeEmployeeAndVehicle()"
              @change="
                fetchTowingPartnerEmployeesListDebounced(true);
                fetchTowingVehiclesListDebounced(true);
                emitValues();
              "
            >
              <template slot="selection" slot-scope="{ item }">
                <span class="text-no-wrap">
                  {{ item.name }} {{ item.first_name ? item.first_name : "" }}
                </span>
              </template>
              <template slot="item" slot-scope="{ item }">
                <v-list-item-content>
                  <p class="towing_name">
                    {{ item.name }} {{ item.first_name }}
                  </p>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- Towing Employee -->
          <v-col class="pt-0">
            <v-autocomplete
              :disabled="!towing_partner"
              :autocomplete="autocompleteValueLocal"
              ref="towingPartnerEmployeeName"
              v-model="towing_partner_employee"
              :label="$t('mission.employee')"
              :items="towingPartnerEmployees"
              item-value="id"
              item-text="name"
              required
              class="to-upper clickable_label"
              v-on:keydown="handleInput($event, 'everything', 50)"
              :search-input.sync="searchTowingPartnerEmployees"
              no-filter
              v-on:keydown.enter.prevent=""
              return-object
              single-line
              hide-no-data
              clearable
              @click:clear="removeVehicle()"
              @change="fetchTowingPartnerEmployeesListDebounced(true)"
            >
              <template slot="selection" slot-scope="{ item }">
                <span class="text-no-wrap">
                  {{ item.name }} {{ item.first_name ? item.first_name : "" }}
                </span>
              </template>
              <template slot="item" slot-scope="{ item }">
                <v-list-item-content>
                  <p class="towing_name">
                    {{ item.name }} {{ item.first_name }}
                  </p>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
          <!-- Towing Vehicle -->
          <v-col class="pt-0">
            <v-autocomplete
              :disabled="!towing_partner"
              :autocomplete="autocompleteValueLocal"
              ref="towingPartnerVehicle"
              v-model="towing_vehicle"
              :label="$t('mission.towing_vehicle')"
              :items="towingVehicles"
              item-value="id"
              item-text="name"
              required
              class="to-upper clickable_label"
              v-on:keydown="handleInput($event, 'everything', 50)"
              :search-input.sync="searchTowingVehicle"
              no-filter
              v-on:keydown.enter.prevent=""
              return-object
              @change="emitValues()"
              single-line
              hide-no-data
              clearable
            >
              <template slot="selection" slot-scope="{ item }">
                <span class="text-no-wrap">
                  {{ item.registration_number }}
                </span>
              </template>
              <template slot="item" slot-scope="{ item }">
                <v-list-item-content>
                  <p class="registration_number">
                    {{ item.registration_number }}
                  </p>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
          <!-- Notify Partner -->
          <v-col cols="12" sm="2" class="mb-0 pb-0">
            <div class="d-flex justify-end align-center mt-0">
              <span class="mr-2 text-orange">{{
                $t("mission.notify_partner")
              }}</span>
              <v-simple-checkbox
                v-model="notify_partners"
                hide-details
                class="ma-0 pa-0"
                value="false"
                label=""
                color="warning"
              />
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { API_BASE_URL } from "@/config";
// import { maxLength } from "vuelidate/lib/validators";
import axios from "@/plugins/axios";
import CreateEditVehicle from "@/components/Vehicles/CreateEditVehicle";
import AddressInput from "@/components/AddressInput";
import VueTelInputVuetify from "@/components/PhoneNumberInput";
import CustomMoneyInput from "@/components/CustomInputs/MoneyInput";

export default {
  name: "CreateEditMission",
  components: {
    "vue-tel-input-vuetify": VueTelInputVuetify,
    "custom-money-input": CustomMoneyInput,
    CreateEditVehicle,
    AddressInput,
  },
  mixins: [validationMixin],
  validations: {},
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
    mission_contact: [String, Object],
    mission_vehicle: [String, Object],
    mission_source_location: [String, Object],
    mission_destination_location: [String, Object],
    mission_reference: [String],
    mission_mission_type: [String, Object, Number],
    mission_mission_id: [Number],
    mission_price: [Number],
    mission_towing_partner: [String, Object],
    mission_notify_partners: [Boolean],
    mission_towing_partner_employee: [String, Object],
    mission_note: [String, Object],
    selectedBill: [String, Object],
  },
  data() {
    return {
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      attachmentDialog: false,
      autocompleteValueLocal: "off",
      selectedMission: null,
      allowContinueSearch: true,
      missions: [],
      search_mission: null,
      isLoadingSearchRegMissions: false,

      destination_location: null,
      source_location: null,
      // Contact
      contact: {
        name: null,
        phone: null,
        gsm: null,
      },

      // Vehicle
      vehicle: {
        id: null,
        vehicle_type_id: null,
        registration_number: null,
        brand_id: null,
        model: null,
        km: null,
        creditor_id: null,
        vin: null,
        color: null,
        is_leasing: null,
      },

      reference: null,
      mission_type: null,
      price: null,
      towing_partner: null,
      towing_vehicle: null,
      towingPartners: [],

      towing_partner_employee: null,
      towingPartnerEmployees: [],
      searchTowingPartnerEmployees: null,

      searchTowingVehicle: null,
      searchTowingPartner: null,
      towingVehicles: [],

      missionStatuses: [],
      status_id: null,

      notify_partners: true,

      header: {
        Authorization: "Bearer " + this.$store.state.AccessToken,
      },
    };
  },
  async mounted() {
    await this.getStatuses();
    this.resetData();
    this.autocompleteValueLocal = this.autocompleteValue();

    this.contact.name = this.mission_contact?.name;
    this.contact.phone = this.mission_contact?.phone;
    this.contact.gsm = this.mission_contact?.gsm;

    this.vehicle = { ...this.mission_vehicle }; // clone to avoid direct mutation
    this.source_location = this.mission_source_location;
    this.destination_location = this.mission_destination_location;
    this.reference = this.mission_reference;
    this.mission_type = this.mission_mission_type;
    this.price = this.mission_price;
    this.towing_partner = this.mission_towing_partner;
    this.towing_partner_employee = this.mission_towing_partner_employee;
    this.note = this.mission_note;
    this.towing_vehicle = this.mission_towing_vehicle;
    if (
      !this.mission_mission_type &&
      this.missionTypes &&
      this.missionTypes.length > 0
    ) {
      this.mission_type = this.missionTypes[0];
    }
    console.log("mission----", this.selectedBill);

    this.emitValues(); // Emit full object once component is mounted
  },
  activated() {
    // this.setDefaultProjectStatus();
    this.resetData();
  },
  deactivated() {
    this.resetData();
  },
  destroyed() {
    this.resetData();
  },
  methods: {
    async getStatuses() {
      await this.getCodes("mission_statuses", "mission.statuses").then(
        (data) => {
          this.missionStatuses = data;
        }
      );
    },
    removeEmployeeAndVehicle() {
      this.towing_partner_employee = null;
      this.towingPartnerEmployees = [];

      this.towing_vehicle = null;
      this.towingVehicles = [];
    },
    removeVehicle() {
      this.towing_vehicle = null;
    },
    fetchTowingPartnerEmployeesListDebounced(autoSearch = false) {
      if (
        (!this.searchTowingPartnerEmployees ||
          typeof this.searchTowingPartnerEmployees == "object") &&
        autoSearch == false
      ) {
        return;
      }

      let towingPartnerRepresentativeId = this.towing_partner
        ? typeof this.towing_partner == "object"
          ? this.towing_partner.representative_company_id
          : this.towing_partner
        : null;
      if (!towingPartnerRepresentativeId) {
        return;
      }

      axios
        .get(
          API_BASE_URL +
            "/clients/search?membersOnly=1" +
            (towingPartnerRepresentativeId
              ? "&representative_company_id=" + towingPartnerRepresentativeId
              : "") +
            (this.searchTowingPartnerEmployees
              ? "&search=" +
                encodeURIComponent(this.searchTowingPartnerEmployees)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.towingPartnerEmployees = data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    fetchMissionSuggestedListDebounced() {
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchMissionSuggestedList();
      }, 500); /* 500ms throttle */
    },
    fetchMissionSuggestedList() {
      if (!this.search_mission || typeof this.search_mission == "object") {
        this.isLoadingSearchRegMissions = false;
        return;
      }
      axios
        .get(
          API_BASE_URL +
            "/missions?page=1&items_per_page=20&not_assigned=1&status_id=10891005" +
            (this.search_mission
              ? "&search=" + encodeURIComponent(this.search_mission)
              : ""),
          { headers: this.header, signal: this.abortController() }
        )
        .then(({ data }) => {
          this.missions = data.data;
        })
        .catch((err) => {
          console.log(err);
          this.isLoadingSearchRegMissions = false;
        })
        .finally(() => (this.isLoadingSearchRegMissions = false));
    },
    resetData() {
      this.destination_location = null;
      this.source_location = null;
      // Contact
      this.contact = {
        name: null,
        phone: null,
        gsm: null,
      };

      // Vehicle
      this.vehicle = {
        id: null,
        vehicle_type_id: null,
        registration_number: null,
        brand_id: null,
        model: null,
        km: null,
        creditor_id: null,
        vin: null,
        color: null,
        is_leasing: null,
      };

      (this.reference = null), (this.mission_type = null);
      this.price = null;
      this.status_id = null;
      this.towing_partner = null;
      this.towing_partner_employee = null;
      this.towing_vehicle = null;
      this.towingPartners = [];
      this.searchTowingVehicle = null;
      this.searchTowingPartner = null;
      this.towingVehicles = [];
      this.note = null;

      this.missions = [];
      this.selectedMission = null;
      console.log("mission reset");
    },
    emitValues() {
      this.$emit("update:mission_vehicle", this.formatVehicle());
      this.$emit("update:mission_contact", this.contact);
      this.$emit("update:mission_source_location", this.source_location);
      this.$emit(
        "update:mission_destination_location",
        this.destination_location
      );
      this.$emit("update:mission_reference", this.reference);
      this.$emit("update:mission_mission_type", this.mission_type);
      this.$emit("update:mission_mission_id", this.selectedMission?.id);
      this.$emit("update:mission_price", this.price);
      this.$emit("update:mission_towing_partner", this.towing_partner);
      this.$emit(
        "update:mission_towing_partner_employee",
        this.towing_partner_employee
      );
      this.$emit("update:mission_towing_vehicle", this.towing_vehicle);
      this.$emit("update:mission_notify_partners", this.notify_partners);
      this.$emit("update:mission_note", this.note);
    },
    formatVehicle() {
      if (!this.vehicle) {
        return null;
      }
      console.log("vehicle", this.vehicle);
      return {
        brand_id:
          typeof this.vehicle?.brand == "object"
            ? this.vehicle?.brand?.id
            : this.vehicle?.brand,
        is_leasing: this.vehicle?.is_leasing,
        km: this.vehicle?.km,
        vin: this.vehicle?.vin,
        color: this.vehicle?.color,
        model: this.vehicle?.model,
        registration_number:
          typeof this.vehicle?.registration_number == "object"
            ? this.vehicle?.registration_number?.registration_number
            : this.vehicle?.registration_number,
        id:
          typeof this.vehicle?.registration_number == "object"
            ? this.vehicle?.registration_number?.id
            : null,
        vehicle_type_id:
          typeof this.vehicle?.vehicle_type_id == "object"
            ? this.vehicle?.vehicle_type_id?.id
            : this.vehicle?.vehicle_type_id,
      };
    },
    fetchTowingPartnersListDebounced() {
      if (
        !this.searchTowingPartner ||
        typeof this.searchTowingPartner == "object"
      ) {
        return;
      }

      axios
        .get(
          API_BASE_URL +
            "/clients/search?towing_partner=1" +
            (this.searchTowingPartner
              ? "&search=" + encodeURIComponent(this.searchTowingPartner)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.towingPartners = data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },

    fetchTowingVehiclesListDebounced(autoSearch = false) {
      if (
        (!this.searchTowingVehicle ||
          typeof this.searchTowingVehicle == "object") &&
        autoSearch == false
      ) {
        return;
      }
      console.log(
        "Towing partner",
        typeof this.towingPartner,
        this.towingPartner
      );
      axios
        .get(
          API_BASE_URL +
            "/client_vehicles?" +
            (this.towing_partner
              ? "client_id=" +
                (typeof this.towing_partner == "object"
                  ? this.towing_partner.id
                  : this.towing_partner)
              : "") +
            (this.searchTowingVehicle
              ? "&search=" + encodeURIComponent(this.searchTowingVehicle)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.towingVehicles = data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    setSelectedMission(data) {
      // used by parents
      console.log("mission from parent", data);
      this.selectedMission = data;
    },
  },
  computed: {
    currencySymbol() {
      return this.userCurrencySymbol;
    },
  },
  watch: {
    searchTowingPartnerEmployees(val) {
      console.log("vall", val);
      if (!val || this.towing_partner_employee == val) {
        return;
      }
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchTowingPartnerEmployeesListDebounced();
      }, 500);
    },
    vehicle: {
      handler() {
        this.emitValues();
      },
      deep: true,
    },
    search_mission(val) {
      if (val && typeof val == "object") {
        this.search_mission = val.identifier;
        this.allowContinueSearch = false;
        return;
      }

      if (val && this.allowContinueSearch) {
        if (
          !val ||
          (this.selectedMission && this.selectedMission.identifier == val)
        ) {
          return;
        }
        this.isLoadingSearchRegMissions = true;
        this.fetchMissionSuggestedListDebounced();
      }
      this.allowContinueSearch = true;
    },
    selectedMission: {
      handler: function (val) {
        if (val && typeof val == "object") {
          this.missions = [val];
          this.contact = val?.object_vehicle?.client
            ? {
                name: val?.object_vehicle?.client?.name,
                phone: val?.object_vehicle?.client?.phone,
                gsm: val?.object_vehicle?.client?.gsm,
                id: val.object_vehicle?.client?.id ?? null,
              }
            : null;
          this.vehicle = val?.object_vehicle
            ? {
                id: val?.object_vehicle?.id,
                vehicle_type_id: val?.object_vehicle?.vehicle_type,
                registration_number: val?.object_vehicle,
                brand_id: val?.object_vehicle?.brand,
                model: val?.object_vehicle?.model,
                km: val?.object_vehicle?.km,
                creditor_id: val?.object_vehicle?.creditor_id,
                vin: val?.object_vehicle?.vin,
                color: val?.object_vehicle?.color,
                is_leasing: val?.object_vehicle?.is_leasing,
              }
            : null;
          console.log("mission", this.vehicle);
          this.source_location = val?.source_location;
          this.destination_location = val?.destination_location;
          this.reference = val?.reference;
          this.price = parseFloat(val?.price ?? 0);
          console.log("value", val);

          if (val.status_id) {
            this.status_id = val.status_id;
          }
          if (val.towing_partner) {
            this.towingPartners = [val.towing_partner];
            this.towing_partner = val.towing_partner;
          }

          if (val.towing_partner_employee_id) {
            this.towingPartnerEmployees = [val.towing_partner_employee];
            this.towing_partner_employee = val.towing_partner_employee;
          }

          this.towingVehicles = [val?.towing_vehicle];
          this.towing_vehicle = val?.towing_vehicle;

          this.mission_type = val?.mission_type_id;
          this.note = val?.note;

          if (!this.selectedBill) {
            console.log("emitting", val?.client_id);
            this.$emit("clientChanged", val?.client_id);
          }
        } else {
          this.resetData();
        }
      },
      immediate: true,
    },
    selectedBill: {
      handler: function () {
        if (
          this.selectedBill &&
          typeof this.selectedBill == "object" &&
          this.selectedBill.mission &&
          typeof this.selectedBill.mission == "object"
        ) {
          setTimeout(() => {
            this.selectedMission = this.selectedBill.mission;
          }, 500);
        }
      },
      immediate: true,
    },

    searchTowingPartner(val) {
      console.log("vall", val);
      if (!val || this.towingPartner == val) {
        return;
      }
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchTowingPartnersListDebounced();
      }, 500);
    },

    searchTowingVehicle(val) {
      if (!val || this.towingVehicle == val) {
        return;
      }
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchTowingVehiclesListDebounced();
      }, 500);
    },
  },
};
</script>

<style scoped></style>
